<template lang="html">
  <div class="breadcrumb_container">
    <el-row :gutter="24" >
      <el-col  :span="4" :offset="2">
        <div id="numberCircle1" class="numberCircle">1</div>
      </el-col>
      <el-col :span="4">
        <i class="el-icon-arrow-right"></i>
      </el-col>
      <el-col :span="4">
        <div id="numberCircle2" class="numberCircle">2</div>
      </el-col>
      <el-col :span="4">
        <i class="el-icon-arrow-right"></i>
      </el-col>
      <el-col :span="4">
        <div id="numberCircle3" class="numberCircle">3</div>
      </el-col>
    </el-row>
  </div>

</template>

<script>
export default {
  name: 'Breadcrumbs',
  mounted(){
    this.sectionChanged();
  },
  props: {
    section:0
  },
  data() {
    return {
    }
  },
  watch: {
    section:'sectionChanged',
  },
  methods: {
    // Podemos refactorizar esto más adelante
    // con clases dinámicas
    sectionChanged() {
      for ( let i = 0; i < this.section; i++ ){
        let element = '#numberCircle' + (i + 1);
        let node = document.querySelector(element);
        node.style.backgroundColor = '#4366DE';
        node.style.color = 'white';
        node.style.border = 'none';
      }
    }
  },
}
</script>

<style scoped lang="css">

a {
  text-decoration: none;
}

.numberCircle {
  border-radius: 50%;
  width: 14px;
  height: 14px;
  padding: 4px;
  background: #fff;
  border: 1px solid #666;
  color: #666;
  text-align: center;
  font: 14px Arial, sans-serif;
  display: block;
  margin: auto;
  cursor: pointer;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  position: relative;
  top: 5px;
  box-sizing: content-box;
}

.breadcrumb_container {
  background-color: #F5F7FA;
  width: 100%;
  height: 38px;
  border-radius: 5px;
  padding-top: 6px;
  display: block;
  margin: auto;
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.el-icon-arrow-right {
  text-align: center;
  display: block;
  font-size: 30px;
  opacity: 0.4;
  padding-top: 1px;
}

</style>



// WEBPACK FOOTER //
// src/components/Breadcrumbs.vue